<template lang="pug">
div(v-if="!logo" class="tw-rounded-md tw-bg-black tw-p-4 tw-inline-block")
  v-icon(x-large color="white") mdi-domain
div(v-else class="tw-rounded-md tw-inline-block tw-h-24 tw-w-24 tw-overflow-hidden tw-border tw-border-gray-lighten-1")
  v-img(:src="path(logo)" cover class="tw-h-full tw-w-full")
</template>
<script>
export default {
  props: ['logo'],
};
</script>
